import calcStats from 'calc-stats';
import { GeoTIFFImage } from 'geotiff';
import { iterPixels } from './iter-pixels';

type CalcBandStatOptions = {
  image: GeoTIFFImage;
  bandIndex: number;
  calcStatsOptions?:  Parameters<typeof calcStats>[1];
}
export function calcBandStats({ image, bandIndex, calcStatsOptions }: CalcBandStatOptions) {
  const noDataValue = image.getGDALNoData();

  const pixels = iterPixels({ image, sample: bandIndex });
  // @ts-ignore
  return calcStats(pixels, {...calcStatsOptions, async: true, noData: noDataValue !== null ? noDataValue : undefined});
}
